export default (target) => {
  let clone            
  const execute = (valueTarget) => {
      let temp
      if (Array.isArray(valueTarget)) {
          temp = valueTarget.map((e) =>  execute(e))
      } else if(valueTarget && typeof valueTarget === 'object') {
          if (!temp) temp = {}
          for(const [key, value] of Object.entries(valueTarget)) {
              if (value && typeof value !== 'object') {
                  temp[key] = value
              } else {
                  temp[key] = execute(value)
              }
          }
          return temp
      } else {
          temp = valueTarget
      }
      return temp
  }

  clone = execute(target)
  return clone
}